import request from '@/utils/request'

/**
 * 课程列表
 */
export function getCourseList(data) {
  return request({
    url: 'api/searchCourse',
    method: 'post',
    params: data
  })
}

/**
 * 添加用户课程学习记录
 */
export function addCourseStudyRecord(data) {
  return request({
    url: 'api/addCourseStudyRecord',
    method: 'post',
    params: data
  })
}

/**
 * 获取课程分类
 */
export function getCourseCategory() {
  return request({
    url: 'api/getCourseClassify',
    method: 'post'
  })
}

/**
 * 精选推荐课程
 * @param data
 */
export function getChoiceCourse(data) {
  return request({
    url: 'api/getChoiceCourseWeb',
    method: 'post',
    params: data
  })
}

/**
 * 获取课程详情
 * @param data
 */
export function getCourseDetail(data) {
  return request({
    url: 'api/getCourseDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取章节第一个章节详情
 * @param data
 */
export function getFirstChapter(data) {
  return request({
    url: 'api/getFirstChapter',
    method: 'post',
    params: data
  })
}


/**
 * 获取章节详情
 * @param data
 */
export function getChapterDetail(data) {
  return request({
    url: 'api/getChapterDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取课程评论
 * @param data
 */
export function getCommentList(data) {
  return request({
    url: 'api/getCommenList',
    method: 'post',
    params: data
  })
}

/**
 * 添加课程评论
 * @param data
 */
export function addComment(data) {
  return request({
    url: 'api/addComment',
    method: 'post',
    params: data
  })
}

